import React from 'react';


const ErrorMessage = ({ error = [] }) => {
  return (
    <div className="ui small negative message ht-error-message">
      <ul className="list">
        {error.map((e, i) => <li key={i}>{e}</li>)}
      </ul>
    </div>
  );
}
 

export default ErrorMessage;
